module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Regular.573f4b83.woff";